import React from 'react';
import { Star } from 'lucide-react';
interface QuickTestimonialProps {
  text: string;
  name: string;
  role: string;
  location: string;
}
const QuickTestimonial = ({
  text,
  name,
  role,
  location
}: QuickTestimonialProps) => <div className="bg-zinc-900 border-2 border-brand-green/40 rounded-lg p-4 shadow-lg hover:border-brand-green transition-colors flex flex-col h-full" data-id="element-264">
    <div className="flex text-brand-yellow mb-1.5" data-id="element-265">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-266" />)}
    </div>
    <p className="text-zinc-200 italic text-xs md:text-sm leading-relaxed mb-3 flex-grow" data-id="element-267">
      "{text}"
    </p>
    <div className="border-t border-brand-green/30 pt-2" data-id="element-268">
      <p className="font-bold text-white text-xs md:text-sm" data-id="element-269">— {name}</p>
      <p className="text-[10px] md:text-xs text-brand-greenLight font-semibold" data-id="element-270">
        {role} · {location}
      </p>
    </div>
  </div>;
export function SocialProofBar() {
  const testimonials = [{
    text: 'Antes perdíamos muchísimo tiempo cargando y separando animales. Adaptamos uno de los diseños del sistema y el manejo cambió completamente.',
    name: 'Carlos Medina',
    role: 'Productor Ganadero',
    location: 'Santa Fe'
  }, {
    text: 'Lo que más me sirvió fue poder visualizar distintas configuraciones antes de construir. Ahorré errores y materiales.',
    name: 'Javier Benítez',
    role: 'Productor Rural',
    location: 'Corrientes'
  }, {
    text: 'Tenía corrales improvisados desde hace años. Este sistema me ayudó a organizar mejor todo el trabajo del campo.',
    name: 'Sergio Álvarez',
    role: 'Productor Ganadero',
    location: 'Córdoba'
  }];
  return <section className="bg-zinc-950 py-7 md:py-10 px-4 border-y-2 border-brand-green" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-273">
          {testimonials.map((t, i) => <QuickTestimonial key={i} {...t} data-id="element-274" />)}
        </div>
      </div>
    </section>;
}